import { createLogger } from '@ringba/core/logger';

export const logger = createLogger('[SystemFlagsClient]');
